import { useState, type FormEvent } from 'react'
import { Button, Input } from '@/components/ui'
import { trpc } from '@/lib/trpc'

export function Login({
  onSuccess,
  onRegister,
}: {
  onSuccess: () => void
  onRegister?: () => void
}) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const login = trpc.auth.login.useMutation({ onSuccess })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    login.mutate({ email, password })
  }

  return (
    <div className="h-full flex items-center justify-center bg-bg-primary">
      <form onSubmit={submit} className="card p-6 w-80 space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md bg-accent flex items-center justify-center">
            <span className="text-white text-sm font-bold leading-none">M</span>
          </div>
          <div>
            <p className="text-sm font-semibold text-text-primary leading-none">Mavatech CRM</p>
            <p className="text-2xs text-text-tertiary leading-none mt-0.5">Anmeldung</p>
          </div>
        </div>
        <Input
          label="Benutzername oder E-Mail"
          type="text"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Input
          label="Passwort"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {login.error && <p className="text-xs text-danger">{login.error.message}</p>}
        <Button type="submit" variant="primary" className="w-full" loading={login.isPending}>
          Anmelden
        </Button>
        {onRegister && (
          <button
            type="button"
            onClick={onRegister}
            className="w-full text-xs text-text-tertiary hover:text-text-secondary"
          >
            Neuen Betrieb registrieren
          </button>
        )}
      </form>
    </div>
  )
}
